import {EventTypes} from '../../types';
import {getChannelAndScopeKey} from '../functions/getChannelAndScopeKey';
import {getMockSubscriptionsSingleton} from './getMockSubscriptionsSingleton';

export const emitMockPusherMessage = <TData>(
  channelName: string,
  scope: string | number | undefined,
  event: EventTypes,
  message: TData,
) => {
  const subscriptionsSingleton = getMockSubscriptionsSingleton();
  subscriptionsSingleton[getChannelAndScopeKey(channelName, scope)].callback(
    event,
    message,
  );
};
